import { Navigate, Outlet, Route } from "react-router-dom";
import lazyRoute from "@/router/lazy-route";

const FeeSchedule = lazyRoute(
  () => import("@/components/app/provider/billing/FeeSchedule")
);
const BillingLayout = lazyRoute(
  () => import("@/pages/app/provider/billings/BillingsLayout")
);
const CreatePRInvoiceLayout = lazyRoute(
  () => import("@/pages/app/provider/billings/CreatePRInvoiceLayout")
);
const SuperBillingLayout = lazyRoute(
  () => import("@/pages/app/provider/billings/SuperBillingLayout")
);
const UpdateSuperBillingLayout = lazyRoute(
  () => import("@/pages/app/provider/billings/UpdateSuperBillingLayout")
);
const ViewSuperBillingLayout = lazyRoute(
  () => import("@/pages/app/provider/billings/ViewSuperBillingLayout")
);
const AccountReceivableLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/AccountReceivableLayout")
);
const InsuranceListingTable = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/insurance/InsuranceListingTable")
);
const PatientListingTable = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/patient/PatientListingTable")
);
const AccountReceivableSummery = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/summery/AccountReceivableSummery")
);
const UpdateEraEobDetails = lazyRoute(
  () => import("@/pages/app/provider/billings/claims/UpdateEraEobDetails")
);
const UpdateClaimsLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/claims/updateClaims/UpdateClaimsLayout")
);
const EraDetailPage = lazyRoute(
  () => import("@/pages/app/provider/billings/era-eob/EraDetailPage")
);
const PatientPayments = lazyRoute(
  () => import("@/pages/app/provider/billings/payments/PatientPayments")
);
const ReadyForBillingTab = lazyRoute(
  () => import("@/pages/app/provider/billings/ReadyForBillingTab")
);
const SuperBill = lazyRoute(
  () => import("@/pages/app/provider/billings/SuperBill")
);
const EraEobTab = lazyRoute(
  () => import("@/pages/app/provider/billings/era-eob/EraEobTab")
);
const EraWorklist = lazyRoute(
  () => import("@/pages/app/provider/billings/era-eob/EraWorklist")
);
const EobWorklist = lazyRoute(
  () => import("@/pages/app/provider/billings/era-eob/EobWorklist")
);
const AccountReceivableInsuranceTable = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/insurance/AccountReceivableInsuranceTable")
);
const AccountReceivablePatientTable = lazyRoute(
  () =>
    import("@/pages/app/provider/billings/account-receivable/patient/AccountReceivablePatientTable")
);
const ClaimsList = lazyRoute(
  () => import("@/pages/app/provider/billings/claims/ClaimsList")
);

export const BillingRoutes = () => (
  <Route path="billing" element={<Outlet />}>
    <Route path="claims/edit-claim" element={<UpdateClaimsLayout />} />
    <Route path="update-era-eob" element={<UpdateEraEobDetails />} />
    <Route element={<BillingLayout />}>
      <Route index element={<ReadyForBillingTab />} />
      <Route path="claims" element={<ClaimsList />}></Route>
      <Route path="invoice" element={<SuperBill />} />
      <Route path="era_eob" element={<EraEobTab />}>
        <Route index element={<Navigate to="era" replace />} />
        <Route path="era" element={<EraWorklist />} />
        <Route path="eob" element={<EobWorklist />} />
      </Route>
    </Route>

    {/* invoice from encounter  */}
    <Route
      path="invoice/:patientId/:encounterId"
      element={<SuperBillingLayout />}
    />

    {/* new invoice  using*/}
    <Route path="add-invoice" element={<SuperBillingLayout />} />

    {/* modify invoice  using*/}
    <Route
      path="update-invoice/:patientId/:superBillId"
      element={<UpdateSuperBillingLayout />}
    />

    {/* view invoice  using*/}
    <Route
      path="view-invoice/:patientId/:superBillId"
      element={<ViewSuperBillingLayout />}
    />

    {/* create PR invoice from claim */}
    <Route
      path="create-pr-invoice/:patientId/:claimId"
      element={<CreatePRInvoiceLayout />}
    />

    <Route path="era-eob/:eraUuid" element={<EraDetailPage />} />

    {/* <Route path="payments" element={<Payments />} /> */}
    <Route path="payments" element={<PatientPayments />} />

    <Route path="account-receivable" element={<AccountReceivableLayout />}>
      <Route path="summary" element={<AccountReceivableSummery />} />
      <Route path="patient" element={<AccountReceivablePatientTable />} />
      <Route path="insurance" element={<AccountReceivableInsuranceTable />} />
      <Route path="patient-listing/:id" element={<PatientListingTable />} />
      <Route path="payer-listing/:id" element={<InsuranceListingTable />} />
    </Route>
    <Route path="fee-schedule" element={<FeeSchedule />} />
  </Route>
);
